import { btnDelay, usePlaySound } from "common/utils";
import i18n from "features/parent/i18n";
import { UserActivityLog } from "features/parent/types";
import {
  getActivityIconClass,
  getActivityIcon,
  getActivityTitle,
  formatActivityTime,
} from "./playerTabUtils";

interface RecentActivitySectionProps {
  activities: UserActivityLog[];
  onShowMore: () => void;
}

export function RecentActivitySection({ activities, onShowMore }: RecentActivitySectionProps) {
  const play = usePlaySound();

  return (
    <div className="flex-col-el w-full overflow-hidden rounded-[12px] p-6">
      <div className="flex-row-el items-center gap-2 text-[24px] text-textcolor-black mb-5 pb-3 border-b border-outline relative">
        <span className="material-symbols-outlined !text-[45px] text-red-100">history</span>
        {i18n.t("MSG_PARENT_PAGE_RECENT_ACTIVITY")}
        {activities.length > 5 && (
          <button
            className="absolute right-0 bottom-3 flex-row-el items-center gap-1 px-4 py-2 bg-white border border-gray2-60 rounded-full text-[21px] text-textcolor-black cursor-pointer hover:bg-gray2-20 transition-all"
            onClick={() => {
              play();
              btnDelay(onShowMore);
            }}
          >
            {i18n.t("MSG_PARENT_PAGE_PLAYER_SHOW_MORE")}
          </button>
        )}
      </div>
      <div className="flex-col-el">
        {activities.length > 0 ? (
          activities.slice(0, 5).map((activity, index) => (
            <div
              key={activity.id}
              className={`flex-row-el gap-3 py-3 ${
                index < Math.min(activities.length, 5) - 1 ? "border-b border-outline" : ""
              }`}
            >
              <div
                className={`w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0 ${getActivityIconClass(activity.activity_type)}`}
              >
                <span className="material-symbols-outlined text-[30px]">
                  {getActivityIcon(activity.activity_type)}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-[21px] text-textcolor-black mb-0.5 truncate">
                  {getActivityTitle(activity)}
                </div>
                <div className="text-[18px] text-gray2-100">
                  {formatActivityTime(activity.activity_at)}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-[21px] text-gray2-100 text-center py-4">
            {i18n.t("MSG_PARENT_PAGE_NO_ACTIVITY_24H")}
          </div>
        )}
      </div>
    </div>
  );
}
